import { Plugin, ButtonView } from 'ckeditor5'

import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import {
  messageBoxShowAction,
  messageBoxHideAction,
} from 'src/reducers/message-box/action'
import BlockOptionsModal from './block-options'

const hideAllMessageBoxes = dispatch => {
  dispatch(messageBoxHideAction())
}
export const handleAddModal = (dispatch, editor, selection) => {
  // First, hide all existing message boxes
  hideAllMessageBoxes(dispatch)

  // Setup the outside click handler
  const handleClickOutside = event => {
    const messageBox0 = document.getElementById('message-box-0')
    const messageBox1 = document.getElementById('message-box-1')

    // Get the collection of color pickers
    const chromePickers = document.getElementsByClassName('chrome-picker')

    // Check if click is inside any color picker
    let isInsideColorPicker = false
    if (chromePickers && chromePickers.length > 0) {
      // Loop through all color pickers to check if the click was inside any of them
      for (let i = 0; i < chromePickers.length; i++) {
        if (chromePickers[i].contains(event.target)) {
          isInsideColorPicker = true
          break
        }
      }
    }

    // Only close if the clicked element is outside of message-box-0
    // and NOT if we're inside message-box-1 or inside a color picker
    if (
      messageBox0 &&
      !messageBox0.contains(event.target) &&
      !isInsideColorPicker &&
      !(messageBox1 && messageBox1.contains(event.target))
    ) {
      document.removeEventListener('mousedown', handleClickOutside)
      dispatch(messageBoxHideAction())
    }
  }

  // Show the new message box
  dispatch(
    messageBoxShowAction(
      MessageBoxContent({
        type: MessageBoxType.WARNING,
        title: `<div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
            "
          >
            <Typography>Block Options</Typography>
          </div>`,
        buttons: [],
        component: <BlockOptionsModal editor={editor} selection={selection} />,
        draggable: true,
        callback: () => {
          // Ensure event listener is removed when modal is closed by other means
          document.removeEventListener('mousedown', handleClickOutside)
        },
      }),
    ),
  )

  // Add the event listener after modal is added to DOM
  document.addEventListener('mousedown', handleClickOutside)
}
class SimpleBoxToolbar extends Plugin {
  constructor(editor) {
    super(editor)
    this.dispatch = editor.config.get('imageGalleryPlugin.dispatch')
  }
  init() {
    const editor = this.editor

    editor.ui.componentFactory.add('blockOptionsSimpleBox', locale => {
      const view = new ButtonView(locale)
      view.set({
        label: 'Block Options',
        withText: true,
        tooltip: true,
        class: 'block-options-simple-box',
      })

      view.on('execute', () => {
        handleAddModal(this.dispatch, editor, editor.model.document.selection)
      })

      return view
    })
  }
}

export default SimpleBoxToolbar
